import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#user_account",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add Menu Action")
  ])
], -1)
const _hoisted_3 = {
  id: "user_account",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { "data-kt-stepper-element": "content" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Select Entity Type", -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Select Role", -1)
const _hoisted_12 = { class: "col-md-2 mt-8" }
const _hoisted_13 = ["data-kt-indicator"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  class: "fw-bolder fs-1",
  style: {"width":"100%","border-bottom":"1px solid #50cd89"}
}, " Menu and Actions ", -1)
const _hoisted_19 = {
  class: "d-flex align-items-center",
  style: {"list-style":"decimal"}
}
const _hoisted_20 = { class: "fs-5 mr-2" }
const _hoisted_21 = ["value", "checked"]
const _hoisted_22 = { class: "text-wrap m-2 fs-5" }
const _hoisted_23 = { style: {"margin-left":"15px"} }
const _hoisted_24 = {
  class: "d-flex align-items-center",
  style: {"list-style":"none"}
}
const _hoisted_25 = ["onUpdate:modelValue", "checked"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "m-2" }, "Maker", -1)
const _hoisted_27 = {
  class: "d-flex align-items-center",
  style: {"list-style":"none"}
}
const _hoisted_28 = ["onUpdate:modelValue", "checked"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "m-2" }, "Checker", -1)
const _hoisted_30 = {
  class: "d-flex align-items-center",
  style: {"list-style":"none"}
}
const _hoisted_31 = ["onUpdate:modelValue", "checked"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "m-2" }, "Approver", -1)
const _hoisted_33 = {
  key: 0,
  class: "col-md-2 mt-8"
}
const _hoisted_34 = ["data-kt-indicator"]
const _hoisted_35 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "form",
    "validation-schema": _ctx.RoleSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Entity Type",
                      modelValue: _ctx.batch.entity_type_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.entity_type_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.getEntityTypesRoles
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTypeList, (entity) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: entity.id,
                            label: entity.name,
                            value: entity.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(entity.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Role",
                      modelValue: _ctx.batch.entity_type_role_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_type_role_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTyperoleList, (role) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: role.id,
                            label: role.label,
                            value: role.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(role.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      class: "btn btn-success",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                      type: "submit",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.menuPermission && _ctx.menuPermission(...args)))
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(" Search ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createTextVNode(" Please wait... "),
                            _hoisted_17
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_13)
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: _ctx.componentKey,
                    class: "py-6"
                  }, [
                    _hoisted_18,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(index + 1) + ". ", 1),
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              name: "menu",
                              "true-value": [],
                              value: item.id,
                              id: "item.id",
                              checked: item.menu_checked
                            }, null, 8, _hoisted_21),
                            _createElementVNode("label", _hoisted_22, _toDisplayString(item.menu_name_en), 1)
                          ]),
                          _createElementVNode("ul", _hoisted_23, [
                            _createElementVNode("li", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.checkedMenu[item.id]) = $event),
                                type: "checkbox",
                                "true-value": [],
                                value: 1,
                                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dataMaker && _ctx.dataMaker(...args))),
                                checked: item.maker
                              }, null, 40, _hoisted_25), [
                                [_vModelCheckbox, _ctx.checkedMenu[item.id]]
                              ]),
                              _hoisted_26
                            ]),
                            _createElementVNode("li", _hoisted_27, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.checkedMenu[item.id]) = $event),
                                type: "checkbox",
                                value: 2,
                                "true-value": [],
                                checked: item.checker
                              }, null, 8, _hoisted_28), [
                                [_vModelCheckbox, _ctx.checkedMenu[item.id]]
                              ]),
                              _hoisted_29
                            ]),
                            _createElementVNode("li", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.checkedMenu[item.id]) = $event),
                                type: "checkbox",
                                "true-value": [],
                                value: 3,
                                checked: item.approver
                              }, null, 8, _hoisted_31), [
                                [_vModelCheckbox, _ctx.checkedMenu[item.id]]
                              ]),
                              _hoisted_32
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.showTable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("button", {
                            "data-kt-indicator": _ctx.loading ? 'on' : null,
                            class: "btn btn-success",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                            type: "submit",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)))
                          }, [
                            (!_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                  _createTextVNode(" Submit "),
                                  _createElementVNode("span", _hoisted_36, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                  _createTextVNode(" Please wait... "),
                                  _hoisted_38
                                ]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}